import { useState } from "react";

import Breadcrumb from "../components/Breadcrumb";
import { Button } from "../components/Form/Button";
import { Input } from "../components/Form/Input";
import { useTwoStepChange } from "../hooks/useTwoStepChange";

const PasswordChange = () => {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [token, setToken] = useState("");
  const {
    loading,
    requested,
    formErrors,
    handleRequest,
    handleConfirm
  } = useTwoStepChange({
    requestUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/private/identity/me/password-change-request`,
    confirmUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/private/identity/me/password`,
    buildRequestBody: () => ({
      password: password,
      password_confirmation: passwordConfirmation,
    }),
    buildConfirmBody: () => ({
      password: password,
      password_confirmation: passwordConfirmation,
      token: token,
    }),
    requestSuccessMessage:
      "Your password change request has been successfully processed. Please take a moment to check your email for the confirmation token.",
    confirmSuccessMessage: "Your password change has been successfully processed.",
    onConfirmSuccess: () => {
      setPassword("");
      setPasswordConfirmation("");
      setToken("");
    },
  });

  return (
    <div className="w-full lg:w-2/3 min-h-screen bg-gray-100 text-gray-900">
      <main className="mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <Breadcrumb
          pages={[
            { name: "My account", href: "#", current: false },
            { name: "Password change", href: "#", current: true },
          ]}
        />
        <div className="mt-8">
          <h1 className="text-xl font-semibold">Password change</h1>
        </div>
        <div className="bg-white mt-6 px-6 pb-6 pt-2">
          <div className="w-full">
            <div className="w-full mt-6">
              <Input
                label="New password"
                name="password"
                placeholder=""
                password={true}
                errors={formErrors}
                value={password}
                setValue={setPassword}
                disabled={loading}
                required={true}
              />
            </div>
            <div className="w-full mt-6">
              <Input
                label="Repeat new password"
                name="password_confirmation"
                placeholder=""
                password={true}
                errors={formErrors}
                value={passwordConfirmation}
                setValue={setPasswordConfirmation}
                disabled={loading}
                required={true}
              />
            </div>
            {requested && (
              <div className="w-full mt-6">
                <Input
                  label="Confirmation token"
                  name="token"
                  placeholder=""
                  errors={formErrors}
                  value={token}
                  setValue={setToken}
                  disabled={loading}
                  required={true}
                  inputMask={(inputText: string) => {
                    return inputText.replaceAll(/[^a-zA-Z0-9]/g, "");
                  }}
                />
              </div>
            )}
          </div>

          <div className="w-full mt-10">
            {!requested && (
              <Button
                label="Request password change"
                disabled={loading}
                theme="primary"
                size="medium"
                className="block w-full md:ml-auto md:w-auto"
                onClick={handleRequest}
              />
            )}
            {requested && (
              <Button
                label="Confirm password change"
                disabled={loading}
                theme="primary"
                size="medium"
                className="block w-full md:ml-auto md:w-auto"
                onClick={handleConfirm}
              />
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default PasswordChange;
